import React from 'react';
import { Typography, Breadcrumb, Form } from 'antd';
import { Link } from 'react-router-dom';
import CategoryForm from '../components/categories/CategoryForm';
import { HomeOutlined, FolderOutlined, PlusOutlined } from '@ant-design/icons';

const { Title } = Typography;

const CategoryCreate: React.FC = () => {
  const [form] = Form.useForm();

  return (
    <div className='p-6'>
      <div className='mb-6'>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to='/admin/dashboard'>
                  <HomeOutlined /> Trang chủ
                </Link>
              ),
            },
            {
              title: (
                <Link to='/admin/categories'>
                  <FolderOutlined /> Danh mục
                </Link>
              ),
            },
            {
              title: (
                <span>
                  <PlusOutlined /> Thêm mới
                </span>
              ),
            },
          ]}
        />
      </div>

      <CategoryForm form={form} />
    </div>
  );
};

export default CategoryCreate;
